import { render, staticRenderFns } from "./TextComment.vue?vue&type=template&id=17ad98c6&scoped=true"
import script from "./TextComment.vue?vue&type=script&setup=true&lang=ts"
export * from "./TextComment.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./TextComment.vue?vue&type=style&index=0&id=17ad98c6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17ad98c6",
  null
  
)

export default component.exports